import React from 'react'
import routes from '../../../config/routes'
import SantanderLogoBlack from '../Icons/SantanderLogoBlack'
import Text from '../Text/Text'
import styles from './menu.module.scss'

export default function Menu() {
  return (
    <ul className={styles.menu}>
      <li>
        <a href={routes.root.path}>
          <Text
            font="custom"
            fontWeight="400"
            size="xxxs"
            color="gray"
            variant="light"
            value="Home"
          />
        </a>
      </li>
      <li>
        <a href={routes.login.path}>
          <Text
            font="custom"
            fontWeight="400"
            size="xxxs"
            color="gray"
            variant="light"
            value="Entrar"
          />
        </a>
      </li>
      <li>
        <a href={routes.registerCNPJ.path}>
          <Text
            font="custom"
            fontWeight="400"
            size="xxxs"
            color="gray"
            variant="light"
            value="Cadastro"
          />
        </a>
      </li>
      <li>
        <SantanderLogoBlack />
      </li>
    </ul>
  )
}
